"use client";

import { useEffect, useState } from "react";
import Selector from "./Selector";
import ChartPreviewDisplay from "./ChartPreviewDisplay";
import { SquareMenu } from "lucide-react";

export default function ChartPreview(props: any) {
  console.log('ChartPreview props: ', props);
  const [openDatasetList, setOpenDatasetList] = useState<string[]>([]);
  const [selectedDivision, setSelectedDivision] = useState<{[datasetId: string]: string}>({});
  const [openSelector, setOpenSelector] = useState(false);

  // lazy-load chartinfo ของ dataset ที่เปิด (ischart: chartInfo เป็น placeholder ว่างจนกว่าจะเปิด)
  useEffect(() => {
    (openDatasetList || []).forEach((id: string) => {
      const ci = props.chartInfo?.[id];
      if (!ci || Object.keys(ci).length === 0) {
        props.onEvent?.({ message: "LoadChartInfoOne", params: { datasetId: id } });
      }
    });
  }, [openDatasetList, props.chartInfo]);

  let {datasetId, selectedTab, hideSelectorPanel = false} = props;

  useEffect(() => {
    console.log('selectedDivisionIHV3: ', props.selectedDivisionIHV3);

    const collectDivisionSelections = (
      chartInfo: any,
      selectedDivision: { id?: string } | null | undefined
    ): Record<string, string> => {
      const out: Record<string, string> = {};
      if (!chartInfo || !selectedDivision?.id) return out;

      for (const sectionKey of Object.keys(chartInfo)) {
        const divisionItems = chartInfo[sectionKey]?.divisionItems;
        if (
          divisionItems &&
          Object.prototype.hasOwnProperty.call(divisionItems, selectedDivision.id)
        ) {
          out[sectionKey] = selectedDivision.id;
        }
      }

      return out;
    };

    // ischart in entire page 
    // allDivisionRead = true => selector ไม่ขึ้นกับ การเลือก division จาก IHV3 (ดูได้ทุก division)
    // allDivisionRead = false => selector ขึ้นกับ division ที่เลือก จาก IHV3 (ดูได้เฉพาะ division ที่เลือกจาก IHV3)

    // ischart in chart page
    // (allDivisionRead=true) bindingDropdown = true และ hideSelectorPanel == true => selector จะ select ตาม selectedDivisionIHV3 ที่ส่งมา

    if (((props.bindingDropdown && props.hideSelectorPanel) || !props.allDivisionRead) && props.selectedDivisionIHV3) {
      const selectionMap = collectDivisionSelections(
        props.chartInfo,
        props.selectedDivisionIHV3
      );

      setSelectedDivision(selectionMap);
      console.log("selectionMap:", selectionMap);
    }
  }, [props.selectedDivisionIHV3, props.allDivisionRead, props.chartInfo])


  let styles= {display: "grid", gridTemplateColumns: hideSelectorPanel ? "100%" : "15% 85%", width: "100vw"}
  if (props.IHV3) {
    styles.width = '100%'
  }

  return (
  <>
    <div style={props.mobile ? { width: "100vw" } : styles}>
      {/* Left Pane - Selector */}
      {!props.mobile && !hideSelectorPanel &&
      <Selector
        datasetId={props.datasetId}
        chartInfo={props.chartInfo}
        openDatasetList={openDatasetList}
        setOpenDatasetList={setOpenDatasetList}
        setState={props.setState}
        onSelect={() => {}}
        selectedTab={selectedTab}
        selectedDivision={selectedDivision}
        setSelectedDivision={setSelectedDivision}
        allDivisionRead={props.allDivisionRead}
      />}

      {/* Right panel - Chart Preview Display */}
      <div style={{position: "relative"}}>
        {props.mobile && !hideSelectorPanel &&
        <>
          <div style={{position: "absolute", left: 10, top: 10, zIndex: 10}}>
            <SquareMenu
              onClick={(e: any) => setOpenSelector(!openSelector)}
            />
          </div>
          {openSelector &&
          <div style={{position: "absolute", left: 0, top: "2rem", zIndex: 20}}>
            <Selector
              datasetId={props.datasetId}
              chartInfo={props.chartInfo}
              openDatasetList={openDatasetList}
              setOpenDatasetList={setOpenDatasetList}
              setState={props.setState}
              onSelect={() => {setOpenSelector(false)}}
              selectedTab={selectedTab}
              selectedDivision={selectedDivision}
              setSelectedDivision={setSelectedDivision}
            />
          </div>}
        </>}

        <ChartPreviewDisplay
          datasetId={props.datasetId}
          selectedTab={props.selectedTab}
          showChart={props.showChart}
          chartInfo={props.chartInfo}
          useCloud={props.useCloud}
          urlPrefix={props.urlPrefix}
          informaticsGs={props.informaticsGs}
          toDownloadUrl={props.toDownloadUrl}
          setState={props.setState}
          onEvent={props.onEvent}
          Admin={props.Admin}
          width={props.width}
          height={props.height}
          filename={props.filename}
          agg={props.agg}
          filter={props.filter}
          colorValues={props.colorValues}
          loggedin={props.loggedin}
          dimList={props.dimList}
          duckLoaded={props.duckLoaded}
          socketMessage={props.socketMessage}
          clearSocketMessage={props.clearSocketMessage}
          selectedDivision={selectedDivision}
          showSelectorDropdown={hideSelectorPanel}
          allDivisionRead={props.allDivisionRead}
          permitToken={props.permitToken}
        />
      </div>
    </div>
  </>
  )
}
